// extracted by mini-css-extract-plugin
export var animationWrapper = "ContactFormWithAnimation-module--animation-wrapper--1596d";